export function useConfirm() {
  return (prompt: string, ok: () => void) => {
    if (typeof window !== 'undefined') {
      if (window.confirm(prompt)) {
        ok();
      }
    }
  };
}
